export default {
    journeySubModules: (state) => {
        return state.journeysList.map((journey) => ({
            text: journey.journey_name,
            value: journey.uuid,
        }));
    },
};
